// Rating universel (stars / pills / emoji)
// - Markup : conteneur [data-rating] + enfants cliquables avec [data-val="1..N"]
// - Hidden <input name="rating"> (optionnel) pour poster un formulaire
(function () {
    function paint(root, value) {
        const btns = root.querySelectorAll('[data-val]');
        btns.forEach(b => {
            const v = Number(b.getAttribute('data-val'));
            b.dataset.active = String(v <= value);
            b.setAttribute('aria-checked', String(v === value));
            b.setAttribute('tabindex', v === value ? '0' : '-1');
        });
        const out = root.querySelector('.rating__value');
        if (out) out.textContent = `${value}/5`;
        const hidden = root.querySelector('input[type="hidden"][name]');
        if (hidden) hidden.value = String(value);
    }

    function setup(root) {
        const btns = [...root.querySelectorAll('[data-val]')];
        if (!btns.length) return;

        const hidden = root.querySelector('input[type="hidden"][name]');
        let value = Number(hidden?.value || root.getAttribute('data-value') || 0);
        value = Math.min(Math.max(value, 0), btns.length);
        root.setAttribute('role', 'radiogroup');

        btns.forEach(b => {
            b.setAttribute('role', 'radio');
            b.addEventListener('click', () => {
                value = Number(b.getAttribute('data-val'));
                paint(root, value);
            });
            b.addEventListener('mouseenter', () => {
                // Prévisualisation au survol pour les étoiles uniquement
                if (root.classList.contains('rating--stars')) {
                    paint(root, Number(b.getAttribute('data-val')));
                }
            });
            b.addEventListener('mouseleave', () => paint(root, value));
        });

        root.addEventListener('keydown', (e) => {
            const max = btns.length;
            if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
                e.preventDefault(); value = Math.min(max, value + 1); paint(root, value);
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
                e.preventDefault(); value = Math.max(1, value - 1); paint(root, value);
            } else if (e.key === 'Home') {
                e.preventDefault(); value = 1; paint(root, value);
            } else if (e.key === 'End') {
                e.preventDefault(); value = max; paint(root, value);
            }
        });

        paint(root, value || 3); // valeur par défaut sympa
    }

    document.querySelectorAll('[data-rating]').forEach(setup);
})();
